import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

import ClockComponent from '../react-components/ClockComponent/ClockComponent.jsx';

function setClockComponent(element) {

    ReactDOM.render(
        <ClockComponent/>
    , element)
}

function init() {
    const $element = $('.c-set-timezone__clock');
    if ($element) {
        $element.each((index, domElement)=>{
            setClockComponent(domElement);
        });
    }
}

export {init}


// WEBPACK FOOTER //
// ./src/_app/user-settings/clock.js